import { render } from "./RoleDrawer.vue?vue&type=template&id=5f81ff7a&scoped=true"
import script from "./RoleDrawer.vue?vue&type=script&lang=js"
export * from "./RoleDrawer.vue?vue&type=script&lang=js"

import "./RoleDrawer.vue?vue&type=style&index=0&id=5f81ff7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f81ff7a"]])

export default __exports__